export const getNumberValue = (value) => {
  if (value.trim() === '') {
    return '0';
  }

  if (/^[0-9\b]+$/.test(value)) {
    const maxValue = 999999999999;
    const valueNumber = parseInt(value, 10);
    let nextValue = valueNumber;
    if (valueNumber > maxValue) {
      nextValue = maxValue;
    }
    return nextValue;
  }

  return false;
};

/**
 * @function
 * @name pricePrecision
 * @param percent {String}
 * @param item {Object}
 * @param config {Object}
 */
export const pricePrecision = (percent, item, config) => {
  const newRate = (Number(item.rate.converted || item.rate.provider) / 100) * Number(percent)
    + Number(item.rate.converted || item.rate.provider)
    + Number(item.auto_rate_fixed);
  const trimed = String(newRate);
  const splited = trimed.split('.');
  const integer = splited[0];
  const fractional = splited[1] || '';
  const precision = config.service_auto_rate_format;

  const includedFraction = fractional?.substring(0, precision);
  const excludedFraction = fractional?.substring(precision);
  const precisionAddon = excludedFraction?.length ? 1 / 10 ** precision : 0;
  const result = (1 * Number(`${integer}.${includedFraction}`) + 1 * precisionAddon).toPrecision(integer.length + precision);
  // eslint-disable-next-line no-restricted-globals
  return !isNaN(result) ? String(Number(result)) : 0;
};
